import React from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function FloatingButtons() {
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3" data-id="element-55">
      <motion.a href="sms:8153540484" initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 1.2,
      type: 'spring',
      stiffness: 200
    }} className="w-14 h-14 bg-blue-500 text-white rounded-full flex items-center justify-center shadow-lg shadow-blue-900/30 hover:bg-blue-600 hover:scale-110 active:scale-95 transition-all duration-200" aria-label="Send us a text message" data-id="element-56">
        <MessageCircleIcon size={24} data-id="element-57" />
      </motion.a>

      <motion.a href="tel:8153540484" initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 1,
      type: 'spring',
      stiffness: 200
    }} className="w-14 h-14 bg-forest-500 text-white rounded-full flex items-center justify-center shadow-lg shadow-forest-900/30 hover:bg-forest-600 hover:scale-110 active:scale-95 transition-all duration-200" aria-label="Call us" data-id="element-58">
        <PhoneIcon size={24} data-id="element-59" />
      </motion.a>
    </div>;
}